import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as RouterProvider } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { ModalProvider } from 'shuffle-display-ui-lib';
import 'styles/_project.scss';
import store from 'store';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <RouterProvider>
        <ModalProvider>
          <App />
        </ModalProvider>
      </RouterProvider>
    </ReduxProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
